export default __webpack_public_path__ + "static/about-2-ea66c0769b449550ece79ec211787e86.jpg";